/* hs-eslint ignored failing-rules */
/* eslint-disable @typescript-eslint/no-floating-promises */

import { useMemo } from 'react';
import { registerQuery, useQuery, DataFetchingClient } from 'data-fetching-client';
// @ts-expect-error untyped import
import { isAcceptanceTest } from 'hub-http/helpers/env';
import Raven from 'raven-js';
import emptyFunction from 'react-utils/emptyFunction';
import { fetchApplicationsViaChirp } from '../api/videoConferenceChirp';
import { useOwnersByIdSearch } from './useOwnersSearch';
import { useUserInfo } from './useUserInfo';
export const AVAILABLE_APPS = registerQuery({
  fieldName: 'videoConferenceApplications',
  args: ['userId'],
  fetcher: ({
    userId
  }) => {
    return fetchApplicationsViaChirp(userId);
  }
});
const client = new DataFetchingClient();
export const useAvailableVideoConferenceExtension = (shouldSkip, ownerId) => {
  var _userInfo$user;
  const userInfo = useUserInfo();
  const currentUserId = userInfo === null || userInfo === void 0 || (_userInfo$user = userInfo.user) === null || _userInfo$user === void 0 ? void 0 : _userInfo$user.user_id;
  const {
    ownersByIdData,
    loadingOwners,
    refetchOwners
  } = useOwnersByIdSearch({
    ownerIds: ownerId ? [ownerId] : [],
    client
  });
  const ownerData = ownersByIdData[0];
  const {
    data: videoConferenceApps,
    refetch: refetchVideoConferenceApps,
    error,
    loading
  } = useQuery(AVAILABLE_APPS, {
    skip: shouldSkip || !userInfo || !!(ownerId && !ownerData),
    client,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    variables: Object.assign({}, ownerData && {
      userId: ownerData.userId
    })
  });
  const handleRefresh = () => {
    refetchVideoConferenceApps();
    if (ownerId) {
      refetchOwners();
    }
  };
  const videoConferenceAppsWithUserInfo = useMemo(() => videoConferenceApps ? Object.assign({}, videoConferenceApps, {
    selectedHostUserId: ownerData === null || ownerData === void 0 ? void 0 : ownerData.userId,
    currentUserId
  }) : videoConferenceApps, [videoConferenceApps, ownerData === null || ownerData === void 0 ? void 0 : ownerData.userId, currentUserId]);
  return {
    videoConferenceApps: videoConferenceAppsWithUserInfo,
    refetchVideoConferenceApps: handleRefresh,
    error,
    loading: loading || loadingOwners
  };
};
export const useAvailableVideoConferenceExtensionByUserId = ({
  shouldSkip,
  userId
}) => {
  const userInfo = useUserInfo();
  const isRunningInAcceptanceTest = isAcceptanceTest();
  let mockedVceAppData = null;
  try {
    const localStorageMockedVceAppData = window.localStorage.getItem('hsmeetingsadminselenium-vce-app');
    if (localStorageMockedVceAppData) {
      mockedVceAppData = JSON.parse(localStorageMockedVceAppData);
    }
  } catch (err) {
    Raven.captureException(err, {
      extra: {
        message: 'Error parsing hsmeetingsadminselenium-vce-app local storage value'
      }
    });
  }
  const {
    data: videoConferenceApps,
    refetch: refetchVideoConferenceApps,
    error,
    loading
  } = useQuery(AVAILABLE_APPS, {
    skip: shouldSkip || !userInfo || isRunningInAcceptanceTest && mockedVceAppData,
    client,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
    variables: {
      userId
    }
  });
  const handleRefresh = () => {
    refetchVideoConferenceApps();
  };
  const mockedVceAppDataResult = {
    videoConferenceApps: undefined,
    refetchVideoConferenceApps: emptyFunction,
    error: null,
    loading: false
  };
  if (isRunningInAcceptanceTest && mockedVceAppData) {
    return Object.assign({}, mockedVceAppDataResult, {
      videoConferenceApps: {
        videoConferenceApplications: mockedVceAppData
      }
    });
  }
  return {
    videoConferenceApps,
    refetchVideoConferenceApps: handleRefresh,
    error,
    loading
  };
};